import React, { useState } from 'react';
import { HeartIcon, Volume2 } from 'lucide-react';
interface MessageBubbleProps {
  message: string;
  isUser: boolean;
  timestamp?: string;
  fontSize?: 'normal' | 'large' | 'x-large';
}
const MessageBubble = ({
  message,
  isUser,
  fontSize = 'normal'
}: MessageBubbleProps) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const handleSpeak = () => {
    setIsSpeaking(true);
    const utterance = new SpeechSynthesisUtterance(message);
    utterance.onend = () => setIsSpeaking(false);
    window.speechSynthesis.speak(utterance);
  };
  const getFontSize = () => {
    switch (fontSize) {
      case 'large':
        return 'text-lg';
      case 'x-large':
        return 'text-xl';
      default:
        return 'text-base';
    }
  };
  return <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`} data-id="element-201">
      {!isUser && <div className="w-6 h-6 rounded-full bg-blue-50 flex items-center justify-center mr-2 flex-shrink-0 mt-1" data-id="element-202">
          <HeartIcon className="w-3 h-3 text-[#E6A4B4]" data-id="element-203" />
        </div>}
      <div className={`
        max-w-[75%] rounded-xl p-3 relative
        ${isUser ? 'bg-[#F8E8E8] text-gray-800' : 'bg-white text-gray-800'}
      `} data-id="element-204">
        <p className={`leading-relaxed ${getFontSize()}`} data-id="element-205">{message}</p>
        {!isUser && <button onClick={handleSpeak} className={`
              absolute -right-8 top-1 p-1.5 rounded-lg transition-all
              ${isSpeaking ? 'bg-lavender text-white' : 'bg-gray-100 dark:bg-slate-700 text-gray-600'}
            `} aria-label={isSpeaking ? 'Stop speaking' : 'Read message aloud'} data-id="element-206">
            <Volume2 className="w-3 h-3" data-id="element-207" />
          </button>}
      </div>
      {isUser && <div className="w-6 h-6 rounded-full bg-[#F8E8E8] flex items-center justify-center ml-2 flex-shrink-0 mt-1" data-id="element-208">
          <span className="text-xs" data-id="element-209">Me</span>
        </div>}
    </div>;
};
export default MessageBubble;